// ideas:
//   cracks in the wall
//   moss on wall
//   gravel on the ground
//   splotches on the wall, just misc marks
//   shorter more dense grass
//   jagged ceiling/floor 

export const FixtureTypeNames = {
    VINE_TOP0: 'V0',
    VINE_TOP1: 'V1',
    VINE_TOP2: 'V2',
    VINE_TOP3: 'V3',
    VINE_TOP4: 'V4',
    VINE_TOP5: 'V5',
    VINE_TOP6: 'V6',
    VINE_TOP7: 'V7',

    VINE_PARTIAL0: 'v0',
    VINE_PARTIAL1: 'v1',
    VINE_PARTIAL2: 'v2',
    VINE_PARTIAL3: 'v3',
    VINE_PARTIAL4: 'v4',
    VINE_PARTIAL5: 'v5',
    VINE_PARTIAL6: 'v6',
    VINE_PARTIAL7: 'v7',

    FLOOR_PLANT0: 'P0',
    FLOOR_PLANT1: 'P1',
    FLOOR_PLANT2: 'P2',
    FLOOR_PLANT3: 'P3',
    FLOOR_PLANT4: 'P4',
    FLOOR_PLANT5: 'P5',
    FLOOR_PLANT6: 'P6',
    FLOOR_PLANT7: 'P7',

    FLOOR_GRASS0: 'G0',
    FLOOR_GRASS1: 'G1',
    FLOOR_GRASS2: 'G2',
    FLOOR_GRASS3: 'G3',
    FLOOR_GRASS4: 'G4',
    FLOOR_GRASS5: 'G5',
    FLOOR_GRASS6: 'G6',
    FLOOR_GRASS7: 'G7',

    FLOOR_MUSHROOM0: 'M0',
    FLOOR_MUSHROOM1: 'M1',
    FLOOR_MUSHROOM2: 'M2',
    FLOOR_MUSHROOM3: 'M3',
    FLOOR_MUSHROOM4: 'M4',
    FLOOR_MUSHROOM5: 'M5',
    FLOOR_MUSHROOM6: 'M6',
    FLOOR_MUSHROOM7: 'M7',

    WALL_FLOWER0: 'W0',
    WALL_FLOWER1: 'W1',
    WALL_FLOWER2: 'W2',
    WALL_FLOWER3: 'W3',
    WALL_FLOWER4: 'W4',
    WALL_FLOWER5: 'W5',
    WALL_FLOWER6: 'W6',
    WALL_FLOWER7: 'W7',

    STALACTITE0: 'S0',
    STALACTITE1: 'S1',
    STALACTITE2: 'S2',
    STALACTITE3: 'S3',
    STALACTITE4: 'S4',
    STALACTITE5: 'S5',
    STALACTITE6: 'S6',
    STALACTITE7: 'S7',

    STALAGMITE0: 's0',
    STALAGMITE1: 's1',
    STALAGMITE2: 's2',
    STALAGMITE3: 's3',
    STALAGMITE4: 's4',
    STALAGMITE5: 's5',
    STALAGMITE6: 's6',
    STALAGMITE7: 's7',

    FLOOR_POKIES0: 'f0',
    FLOOR_POKIES1: 'f1',
    FLOOR_POKIES2: 'f2',
    FLOOR_POKIES3: 'f3',
    FLOOR_POKIES4: 'f4',
    FLOOR_POKIES5: 'f5',
    FLOOR_POKIES6: 'f6',
    FLOOR_POKIES7: 'f7',

    CEILING_POKIES0: 'p0',
    CEILING_POKIES1: 'p1',
    CEILING_POKIES2: 'p2',
    CEILING_POKIES3: 'p3',
    CEILING_POKIES4: 'p4',
    CEILING_POKIES5: 'p5',
    CEILING_POKIES6: 'p6',
    CEILING_POKIES7: 'p7',

    WALL_CRACKS0: 'C0',
    WALL_CRACKS1: 'C1',
    WALL_CRACKS2: 'C2',
    WALL_CRACKS3: 'C3',
    WALL_CRACKS4: 'C4',
    WALL_CRACKS5: 'C5',
    WALL_CRACKS6: 'C6',
    WALL_CRACKS7: 'C7',

    TALL_GRASS0: 'g0',
    TALL_GRASS1: 'g1',
    TALL_GRASS2: 'g2',
    TALL_GRASS3: 'g3',
    TALL_GRASS4: 'g4',
    TALL_GRASS5: 'g5',
    TALL_GRASS6: 'g6',
    TALL_GRASS7: 'g7',

    CEILING_GRASS0: 'c0',
    CEILING_GRASS1: 'c1',
    CEILING_GRASS2: 'c2',
    CEILING_GRASS3: 'c3',
    CEILING_GRASS4: 'c4',
    CEILING_GRASS5: 'c5',
    CEILING_GRASS6: 'c6',
    CEILING_GRASS7: 'c7',

    CURVED_PLANTS0: 'a0',
    CURVED_PLANTS1: 'a1',
    CURVED_PLANTS2: 'a2',
    CURVED_PLANTS3: 'a3',
    CURVED_PLANTS4: 'a4',
    CURVED_PLANTS5: 'a5',
    CURVED_PLANTS6: 'a6',
    CURVED_PLANTS7: 'a7',

    FLOWERS0: 'b0',
    FLOWERS1: 'b1',
    FLOWERS2: 'b2',
    FLOWERS3: 'b3',
    FLOWERS4: 'b4',
    FLOWERS5: 'b5',
    FLOWERS6: 'b6',
    FLOWERS7: 'b7',

    FLOOR_SPIKES0: 'd0',
    FLOOR_SPIKES1: 'd1',
    FLOOR_SPIKES2: 'd2',
    FLOOR_SPIKES3: 'd3',
    FLOOR_SPIKES4: 'd4',
    FLOOR_SPIKES5: 'd5',
    FLOOR_SPIKES6: 'd6',
    FLOOR_SPIKES7: 'd7',

    CEILING_SPIKES0: 'e0',
    CEILING_SPIKES1: 'e1',
    CEILING_SPIKES2: 'e2',
    CEILING_SPIKES3: 'e3',
    CEILING_SPIKES4: 'e4',
    CEILING_SPIKES5: 'e5',
    CEILING_SPIKES6: 'e6',
    CEILING_SPIKES7: 'e7',

    WALL_HOLES0: 'h0',
    WALL_HOLES1: 'h1',
    WALL_HOLES2: 'h2',
    WALL_HOLES3: 'h3',
    WALL_HOLES4: 'h4',
    WALL_HOLES5: 'h5',
    WALL_HOLES6: 'h6',
    WALL_HOLES7: 'h7',
};


export const VINES_TOP = [
    FixtureTypeNames.VINE_TOP0,
    FixtureTypeNames.VINE_TOP1,
    FixtureTypeNames.VINE_TOP2,
    FixtureTypeNames.VINE_TOP3,
    FixtureTypeNames.VINE_TOP4,
    FixtureTypeNames.VINE_TOP5,
    FixtureTypeNames.VINE_TOP6,
    FixtureTypeNames.VINE_TOP7
];

export const VINES_PARTIAL = [
    FixtureTypeNames.VINE_PARTIAL0,
    FixtureTypeNames.VINE_PARTIAL1,
    FixtureTypeNames.VINE_PARTIAL2,
    FixtureTypeNames.VINE_PARTIAL3,
    FixtureTypeNames.VINE_PARTIAL4,
    FixtureTypeNames.VINE_PARTIAL5,
    FixtureTypeNames.VINE_PARTIAL6,
    FixtureTypeNames.VINE_PARTIAL7,
];

export const FLOOR_PLANTS = [
    FixtureTypeNames.FLOOR_PLANT0,
    FixtureTypeNames.FLOOR_PLANT1,
    FixtureTypeNames.FLOOR_PLANT2,
    FixtureTypeNames.FLOOR_PLANT3,
    FixtureTypeNames.FLOOR_PLANT4,
    FixtureTypeNames.FLOOR_PLANT5,
    FixtureTypeNames.FLOOR_PLANT6,
    FixtureTypeNames.FLOOR_PLANT7,
];

export const FLOOR_GRASS = [
    FixtureTypeNames.FLOOR_GRASS0,
    FixtureTypeNames.FLOOR_GRASS1,
    FixtureTypeNames.FLOOR_GRASS2,
    FixtureTypeNames.FLOOR_GRASS3,
    FixtureTypeNames.FLOOR_GRASS4,
    FixtureTypeNames.FLOOR_GRASS5,
    FixtureTypeNames.FLOOR_GRASS6,
    FixtureTypeNames.FLOOR_GRASS7,
];

export const FLOOR_MUSHROOM = [
    FixtureTypeNames.FLOOR_MUSHROOM0,
    FixtureTypeNames.FLOOR_MUSHROOM1,
    FixtureTypeNames.FLOOR_MUSHROOM2,
    FixtureTypeNames.FLOOR_MUSHROOM3,
    FixtureTypeNames.FLOOR_MUSHROOM4,
    FixtureTypeNames.FLOOR_MUSHROOM5,
    FixtureTypeNames.FLOOR_MUSHROOM6,
    FixtureTypeNames.FLOOR_MUSHROOM7,
];

export const WALL_FLOWERS = [
    FixtureTypeNames.WALL_FLOWER0,
    FixtureTypeNames.WALL_FLOWER1,
    FixtureTypeNames.WALL_FLOWER2,
    FixtureTypeNames.WALL_FLOWER3,
    FixtureTypeNames.WALL_FLOWER4,
    FixtureTypeNames.WALL_FLOWER5,
    FixtureTypeNames.WALL_FLOWER6,
    FixtureTypeNames.WALL_FLOWER7
];

export const STALACTITES = [
    FixtureTypeNames.STALACTITE0,
    FixtureTypeNames.STALACTITE1,
    FixtureTypeNames.STALACTITE2,
    FixtureTypeNames.STALACTITE3,
    FixtureTypeNames.STALACTITE4,
    FixtureTypeNames.STALACTITE5,
    FixtureTypeNames.STALACTITE6,
    FixtureTypeNames.STALACTITE7
];

export const STALAGMITES = [
    FixtureTypeNames.STALAGMITE0,
    FixtureTypeNames.STALAGMITE1,
    FixtureTypeNames.STALAGMITE2,
    FixtureTypeNames.STALAGMITE3,
    FixtureTypeNames.STALAGMITE4,
    FixtureTypeNames.STALAGMITE5,
    FixtureTypeNames.STALAGMITE6,
    FixtureTypeNames.STALAGMITE7,
];

export const FLOOR_POKIES = [
    FixtureTypeNames.FLOOR_POKIES0,
    FixtureTypeNames.FLOOR_POKIES1,
    FixtureTypeNames.FLOOR_POKIES2,
    FixtureTypeNames.FLOOR_POKIES3,
    FixtureTypeNames.FLOOR_POKIES4,
    FixtureTypeNames.FLOOR_POKIES5,
    FixtureTypeNames.FLOOR_POKIES6,
    FixtureTypeNames.FLOOR_POKIES7
];

export const CEILING_POKIES = [
    FixtureTypeNames.CEILING_POKIES0,
    FixtureTypeNames.CEILING_POKIES1,
    FixtureTypeNames.CEILING_POKIES2,
    FixtureTypeNames.CEILING_POKIES3,
    FixtureTypeNames.CEILING_POKIES4,
    FixtureTypeNames.CEILING_POKIES5,
    FixtureTypeNames.CEILING_POKIES6,
    FixtureTypeNames.CEILING_POKIES7
];

// export const WALL_CRACKS = [
//     FixtureTypeNames.WALL_CRACKS0,
//     FixtureTypeNames.WALL_CRACKS1,
//     FixtureTypeNames.WALL_CRACKS2,
//     FixtureTypeNames.WALL_CRACKS3,
//     FixtureTypeNames.WALL_CRACKS4,
//     FixtureTypeNames.WALL_CRACKS5,
//     FixtureTypeNames.WALL_CRACKS6,
//     FixtureTypeNames.WALL_CRACKS7
// ];

export const TALL_GRASS = [
    FixtureTypeNames.TALL_GRASS0,
    FixtureTypeNames.TALL_GRASS1,
    FixtureTypeNames.TALL_GRASS2,
    FixtureTypeNames.TALL_GRASS3,
    FixtureTypeNames.TALL_GRASS4,
    FixtureTypeNames.TALL_GRASS5,
    FixtureTypeNames.TALL_GRASS6,
    FixtureTypeNames.TALL_GRASS7,
];

export const CEILING_GRASS = [
    FixtureTypeNames.CEILING_GRASS0,
    FixtureTypeNames.CEILING_GRASS1,
    FixtureTypeNames.CEILING_GRASS2,
    FixtureTypeNames.CEILING_GRASS3,
    FixtureTypeNames.CEILING_GRASS4,
    FixtureTypeNames.CEILING_GRASS5,
    FixtureTypeNames.CEILING_GRASS6,
    FixtureTypeNames.CEILING_GRASS7,
];

export const CURVED_PLANTS = [
    FixtureTypeNames.CURVED_PLANTS0,
    FixtureTypeNames.CURVED_PLANTS1,
    FixtureTypeNames.CURVED_PLANTS2,
    FixtureTypeNames.CURVED_PLANTS3,
    FixtureTypeNames.CURVED_PLANTS4,
    FixtureTypeNames.CURVED_PLANTS5,
    FixtureTypeNames.CURVED_PLANTS6,
    FixtureTypeNames.CURVED_PLANTS7,
];


export const FLOWERS = [
    FixtureTypeNames.FLOWERS0,
    FixtureTypeNames.FLOWERS1,
    FixtureTypeNames.FLOWERS2,
    FixtureTypeNames.FLOWERS3,
    FixtureTypeNames.FLOWERS4,
    FixtureTypeNames.FLOWERS5,
    FixtureTypeNames.FLOWERS6,
    FixtureTypeNames.FLOWERS7,
];


export const FLOOR_SPIKES = [
    FixtureTypeNames.FLOOR_SPIKES0,
    FixtureTypeNames.FLOOR_SPIKES1,
    FixtureTypeNames.FLOOR_SPIKES2,
    FixtureTypeNames.FLOOR_SPIKES3,
    FixtureTypeNames.FLOOR_SPIKES4,
    FixtureTypeNames.FLOOR_SPIKES5,
    FixtureTypeNames.FLOOR_SPIKES6,
    FixtureTypeNames.FLOOR_SPIKES7,
];

export const CEILING_SPIKES = [
    FixtureTypeNames.CEILING_SPIKES0,
    FixtureTypeNames.CEILING_SPIKES1,
    FixtureTypeNames.CEILING_SPIKES2,
    FixtureTypeNames.CEILING_SPIKES3,
    FixtureTypeNames.CEILING_SPIKES4,
    FixtureTypeNames.CEILING_SPIKES5,
    FixtureTypeNames.CEILING_SPIKES6,
    FixtureTypeNames.CEILING_SPIKES7,
];

export const WALL_HOLES = [
    FixtureTypeNames.WALL_HOLES0,
    FixtureTypeNames.WALL_HOLES1,
    FixtureTypeNames.WALL_HOLES2,
    FixtureTypeNames.WALL_HOLES3,
    FixtureTypeNames.WALL_HOLES4,
    FixtureTypeNames.WALL_HOLES5,
    FixtureTypeNames.WALL_HOLES6,
    FixtureTypeNames.WALL_HOLES7,
];

/**
 * Array of arrays.
 * @type {string[][]}
 */
export const CEILING = [
    VINES_TOP,
    STALACTITES,
    CEILING_POKIES,
    CEILING_GRASS,
    CEILING_SPIKES
];

/**
 * Array of arrays.
 * @type {string[][]}
 */
export const MID = [
    VINES_PARTIAL,
    WALL_FLOWERS,
    WALL_HOLES
];

/**
 * Array of arrays.
 * @type {string[][]}
 */
export const FLOOR = [
    FLOOR_PLANTS,
    FLOOR_GRASS,
    FLOOR_MUSHROOM,
    STALAGMITES,
    FLOOR_POKIES,
    TALL_GRASS,
    CURVED_PLANTS,
    FLOWERS,
    FLOOR_SPIKES
];
